import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { Button } from "../buttons/shadcn-button";
import { cn } from "src/utils";
import { CalendarIcon } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../input/Select";

type MonthYearPickerProps = {
  nameMonth: string;
  nameYear: string;
};

const months = [
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

export function MonthYearPicker({ nameMonth, nameYear }: MonthYearPickerProps) {
  const { setValue, watch } = useFormContext();
  const [open, setOpen] = useState(false);

  const selectedMonth = watch(nameMonth);
  const selectedYear = watch(nameYear);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 21 }, (_, i) =>
    String(currentYear - 10 + i)
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "w-[220px] justify-between rounded-xl shadow-sm",
            !selectedMonth || !selectedYear
              ? "text-muted-foreground"
              : "text-gray-900"
          )}
        >
          {selectedMonth && selectedYear
            ? `${
                months.find((m) => m.value === selectedMonth)?.label
              } ${selectedYear}`
            : "Select Month & Year"}
          <CalendarIcon className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent className="w-[220px] p-4 space-y-4" align="start">
        <div className="space-y-2">
          <label className="text-sm font-medium">Month</label>
          <Select
            value={selectedMonth ?? ""}
            onValueChange={(val) => setValue(nameMonth, val)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select month" />
            </SelectTrigger>
            <SelectContent>
              {months.map((m) => (
                <SelectItem
                  key={m.value}
                  value={m.value}
                >
                  {m.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Year</label>
          <Select
            value={selectedYear ?? ""}
            onValueChange={(val) => setValue(nameYear, val)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select year" />
            </SelectTrigger>
            <SelectContent>
              {years.map((y) => (
                <SelectItem
                  key={y}
                  value={y}
                >
                  {y}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </PopoverContent>
    </Popover>
  );
}